import React from "react";
import { StyledLI } from "./styled";

class Tab extends React.Component {
  handleClick = e => {
    e.preventDefault();
    this.props.handleClick();
  };

  render() {
    return (
      <StyledLI
        key={this.props.id}
        id={this.props.id}
        className={this.props.isActive ? "is-active" : ""}
      >
        <a onClick={this.handleClick}>{this.props.name}</a>
      </StyledLI>
    );
  }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/Tab.js